"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_1 = require("@material-ui/core/Grid");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var react_router_1 = require("react-router");
var Authentication_1 = require("src/Authentication");
var CurrentUser_1 = require("src/CurrentUser");
var LogInForm_1 = require("./LogInForm");
/**
 * Mutation that submits user credentials and retrieves a token
 */
exports.loginMutation = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation LoginMutation ($email: String!, $password: String!, $aliasUUID: String) {\n    login(email: $email, password: $password, aliasUUID: $aliasUUID) {\n      wasSuccessful\n      confirmationError\n      token\n      user {\n        isRowanUser\n        isCanary\n      }\n    }\n  }\n"], ["\n  mutation LoginMutation ($email: String!, $password: String!, $aliasUUID: String) {\n    login(email: $email, password: $password, aliasUUID: $aliasUUID) {\n      wasSuccessful\n      confirmationError\n      token\n      user {\n        isRowanUser\n        isCanary\n      }\n    }\n  }\n"])));
/**
 * Connects the Login form the the graphql Mutations
 */
var LoginPage = /** @class */ (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage(props) {
        var _this = _super.call(this, props) || this;
        /**
         * When the login form is submitted
         * call the mutation, and tell the apollo client to reset
         */
        _this.onLoginSubmit = function (logInFn) { return function (_a) {
            var email = _a.email, password = _a.password, aliasUUID = _a.aliasUUID;
            return __awaiter(_this, void 0, void 0, function () {
                var result, data, _b, token, user;
                var _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0: return [4 /*yield*/, logInFn({ variables: { email: email, password: password, aliasUUID: aliasUUID } })];
                        case 1:
                            result = _e.sent();
                            data = (result || {}).data;
                            if (result === undefined || data === undefined || !data.login.token) {
                                this.props.displayMessage("Login result doesn't contain token.", 'error');
                                return [2 /*return*/];
                            }
                            _b = data.login, token = _b.token, user = _b.user;
                            Authentication_1.AuthToken.setToken(token);
                            Authentication_1.AuthToken.updateCanaryUserCookie((_c = user) === null || _c === void 0 ? void 0 : _c.isRowanUser, (_d = user) === null || _d === void 0 ? void 0 : _d.isCanary);
                            this.props.currentUser.refetch();
                            return [2 /*return*/];
                    }
                });
            });
        }; };
        _this.aliasUUID = props.match && props.match.params && props.match.params.aliasUUID || undefined;
        _this.redirectAfterLogin(props);
        return _this;
    }
    LoginPage.prototype.render = function () {
        var _this = this;
        this.redirectAfterLogin(this.props);
        if (this.props.currentUser.loading || this.props.currentUser.loggedInUser) {
            return null;
        }
        return (React.createElement(react_apollo_1.Mutation, { mutation: exports.loginMutation, fetchPolicy: "no-cache" }, function (logInFn, mutationResult) {
            var loading = mutationResult.loading, error = mutationResult.error, data = mutationResult.data;
            if (data === undefined || !data.login.wasSuccessful) {
                var status_1 = 'ready';
                if (error !== undefined || (data && !data.login.wasSuccessful)) {
                    status_1 = 'error';
                }
                if (loading) {
                    status_1 = 'waiting';
                }
                return (React.createElement(Grid_1.default, { container: true, style: { justifyContent: 'center' } },
                    React.createElement(Grid_1.default, { item: true },
                        React.createElement(LogInForm_1.default, { onSubmit: _this.onLoginSubmit(logInFn), aliasUUID: _this.aliasUUID, status: status_1, errorMessage: data && data.login.confirmationError || undefined }))));
            }
            else {
                return (React.createElement("h3", null, "Login Successfull"));
            }
        }));
    };
    /**
     * Redirect after login back to cached page or to bookshelf
     */
    LoginPage.prototype.redirectAfterLogin = function (props) {
        if (!props.currentUser.loading && props.currentUser.loggedInUser) {
            if (props.postLoginRedirectFn) {
                props.postLoginRedirectFn(getAndClearRedirectAfterAuth());
            }
            else {
                props.history.push(getAndClearRedirectAfterAuth());
            }
        }
    };
    return LoginPage;
}(React.Component));
var REDIRECT_AFTER_AUTH_KEY = 'REDIRECT_AFTER_AUTH';
exports.setRedirectAfterAuth = function (path) {
    localStorage.setItem(REDIRECT_AFTER_AUTH_KEY, path);
};
/**
 * If user is logged in redirect to the library page
 * if the user is not logged in, render with mutation available.
 */
var getAndClearRedirectAfterAuth = function () {
    var redirectPath = localStorage.getItem(REDIRECT_AFTER_AUTH_KEY) || '/library';
    localStorage.removeItem(REDIRECT_AFTER_AUTH_KEY);
    return redirectPath;
};
exports.default = react_router_1.withRouter(CurrentUser_1.withCurrentUser(LoginPage));
var templateObject_1;
